"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _ = require("..");
var _stepindicator = require("./stepindicator.style");
var _react = require("react");
var _helpers = require("../../utils/helpers");
function StepIndicator(_ref) {
  let {
    className = 'stepIndicator',
    currentindex,
    steps,
    orientation,
    completed,
    onClick,
    activeColor = 'primary.blue.300',
    fit,
    customIcon = false
  } = _ref;
  const [activeColorState, setActiveColorState] = (0, _react.useState)(activeColor);
  (0, _react.useEffect)(() => {
    setActiveColorState((0, _helpers.findStyledColor)(activeColor).toString());
  }, [activeColor]);
  const handleClick = key => {
    if (onClick) {
      onClick(key);
    }
  };
  const isHeader = steps === null || steps === void 0 ? void 0 : steps.some(m => m.header);
  return (0, _jsxRuntime.jsx)(_stepindicator.Components.StepperIndicatorWrapper, (0, _extends2["default"])({
    orientation: orientation,
    className: className
  }, {
    children: (0, _jsxRuntime.jsx)(_stepindicator.Components.StepperIndicatorList, (0, _extends2["default"])({
      orientation: orientation
    }, {
      children: steps === null || steps === void 0 ? void 0 : steps.map((item, key) => {
        return (0, _jsxRuntime.jsx)(_stepindicator.Components.StepperIndicatorItem, (0, _extends2["default"])({
          idx: key,
          currentindex: currentindex,
          orientation: orientation,
          completed: completed,
          activeColor: activeColorState,
          header: isHeader
        }, {
          children: (0, _jsxRuntime.jsxs)(_stepindicator.Components.StepperIndicatorItemInner, (0, _extends2["default"])({
            orientation: orientation,
            onClick: () => handleClick(key)
          }, {
            children: [orientation === 'horizontal' && (item === null || item === void 0 ? void 0 : item.header) && (0, _jsxRuntime.jsx)(_stepindicator.Components.StepperIndicatorItemHeader, (0, _extends2["default"])({
              currentindex: currentindex,
              idx: key,
              orientation: orientation,
              completed: completed
            }, {
              children: item.header
            })), (0, _jsxRuntime.jsx)(_stepindicator.Components.StepperIndicatorIconWrapper, (0, _extends2["default"])({
              step: item,
              idx: key,
              currentindex: currentindex,
              fit: fit,
              orientation: orientation,
              completed: completed,
              activeColor: activeColorState,
              customIcon: customIcon
            }, {
              children: (0, _jsxRuntime.jsx)(_.Icon, {
                name: (item === null || item === void 0 ? void 0 : item.icon) || 'check'
              })
            })), orientation === 'vertical' && (item === null || item === void 0 ? void 0 : item.header) && (0, _jsxRuntime.jsx)(_stepindicator.Components.StepperIndicatorItemLabel, (0, _extends2["default"])({
              currentindex: currentindex,
              idx: key,
              orientation: orientation,
              completed: completed,
              defaultStyle: typeof item.title === 'string'
            }, {
              children: item.header
            })), (0, _jsxRuntime.jsx)(_stepindicator.Components.StepperIndicatorItemLabel, (0, _extends2["default"])({
              currentindex: currentindex,
              idx: key,
              orientation: orientation,
              completed: completed,
              defaultStyle: typeof item.title === 'string'
            }, {
              children: item.title
            }))]
          }))
        }), key);
      })
    }))
  }));
}
StepIndicator.defaultProps = {
  orientation: 'horizontal',
  fit: 'medium'
};
var _default = exports["default"] = StepIndicator;